export default __webpack_public_path__ + "static/media/check.6d2a8827.svg";